import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=aaaa236a&scoped=true"
import script from "./MessageTemplates.vue?vue&type=script&lang=js"
export * from "./MessageTemplates.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplates.vue?vue&type=style&index=0&id=aaaa236a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaa236a",
  null
  
)

export default component.exports